import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../servicios/auth.service';
import { GlobalServices } from 'src/app/admin/servicios/globales.services';
import { EmpresaService } from 'src/app/admin/servicios/empresa.service';
import {Router} from '@angular/router';
@Component({
  selector: 'app-recoveryPass',
  templateUrl: './recoveryPass.component.html',
  styleUrls: ['./recoveryPass.component.css']
})
export class RecoveryPassComponent implements OnInit {

  public form: FormGroup; // Para enviar correo de reestablecer Pass
  public errorMessage: string;
  public code: any;
  public loading:boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private global: GlobalServices,
    private empresaService: EmpresaService,
    private router:Router
  ) { }

  ngOnInit():void {
      //  Obtener informacion de la url del navegador
      this.code = window.location.search;
      const urlParams = new URLSearchParams(this.code);
      this.code  = urlParams.get('oobCode');
      this.form = this.fb.group({
        password: ['', Validators.required]
      });
  }

  changePass() {
    const { password } = this.form.value;
    this.loading = true;
    try{
      this.authService.verifyChange(this.code).then( (email:string) => {
        this.authService.changeAuthPass( this.code,password).then( () => {
            this.loading = false;  
            this.empresaService.updateStatePass(email);
            this.global.ngModalAlert('success','Cambio de contraseña','Contraseña modificada exitosamente.',()=>{
              this.router.navigate(['./login']);
            });
        })
     })
    }catch(error){
      console.log(error);
      this.global.ngModalAlert('error','Cambio de contraseña','No se pudo modificar la contraseña')
    }
  }
}
